import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { computed, reactive, onMounted, onBeforeUnmount, watch, ref, nextTick } from "vue";
import { ArrowUp, ArrowDown } from "@element-plus/icons-vue";
export default {
  props: ["questionInfo", "menu", "allAnswers"],
  setup(props, content) {
    let isMountedOver = ref(false);
    let movingItem = reactive({
      text: "",
      id: "",
      isShow: true,
      top: 0,
      left: 0
    });
    //距离
    let distance = reactive([0]);
    //答案
    let answer = reactive({});
    let touchSwitch = ref(false);
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
        });
      });
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question-text")[0].scrollTop = 0;
      document.getElementsByClassName("answer")[0].scrollTop = 0;
      isMountedOver.value = false;
      distance.splice(0, distance.length);
      distance.push(0);
      setTimeout(() => {
        isMountedOver.value = true;
      }, 50);
    });
    //处理题目
    let itemText = computed(() => {
      //处理答案
      let text = props.questionInfo.itemText;
      for (let i = 0;; i++) {
        if (text.indexOf("{{") == -1) break;
        let questionNum = `</p><span style="background: #4bbbff;color:#fff;display:inline;border-radius:5px;min-width: 16px;height:15px;text-align:center;line-height:15px;padding: 2px 6px;font-size:14px">${props.questionInfo.menu + i}</span><p class=" questionBox${i}"></p></br>`;
        text = text.substring(0, text.indexOf("{{")) + questionNum + text.substr(text.indexOf("}}") + 2);
      }
      return text;
    });
    //答案项
    let questionItem = computed(() => {
      let questList = [];
      let list = props.questionInfo.questionGroupList[0].choiceList;
      for (let i = 0; i < list.length; i++) {
        let mark = false;
        for (let key in answer) {
          if (answer[key] == String.fromCodePoint(65 + i)) {
            questList.push({
              text: String.fromCodePoint(65 + i) + "." + list[i].choiceText,
              id: String.fromCodePoint(65 + i),
              isShow: false
            });
            mark = true;
            break;
          }
        }
        if (mark) continue;
        questList.push({
          text: String.fromCodePoint(65 + i) + "." + list[i].choiceText,
          id: String.fromCodePoint(65 + i),
          isShow: true
        });
      }
      return questList;
    });
    onMounted(() => {
      isMountedOver.value = true;
    });
    //拖拽功能
    let {
      positionIndex,
      setQuestion,
      overQuestion,
      moveQuestion,
      setQuestionFromAnswer
    } = useDragAnswer(movingItem, questionItem, setAnswer, answer, distance);
    function setAnswer() {
      content.emit("setAnswer", answer);
    }
    let scrollMoveFlag = true;
    //滚动
    function scrollMove(dom, num, flag) {
      if (flag) {
        if (scrollMoveFlag) {
          document.getElementsByClassName(dom)[0].scrollTop += num;
          setTimeout(() => {
            scrollMove(dom, num, true);
          }, 120);
        }
      } else {
        if (num == 0) {
          scrollMoveFlag = false;
          return 0;
        } else {
          scrollMoveFlag = true;
          document.getElementsByClassName(dom)[0].scrollTop += num;
          setTimeout(() => {
            scrollMove(dom, num, true);
          }, 120);
        }
      }
    }
    return {
      touchSwitch,
      scrollMove,
      distance,
      positionIndex,
      setQuestionFromAnswer,
      itemText,
      questionItem,
      isMountedOver,
      answer,
      movingItem,
      overQuestion,
      moveQuestion,
      setQuestion,
      ArrowUp,
      ArrowDown
    };
  }
};
function useDragAnswer(movingItem, questionItem, setAnswer, answer, distance) {
  let dealingId = null;
  let positionIndex = ref(-1);
  onMounted(() => {
    window.addEventListener("mouseup", overQuestion);
    window.addEventListener("touchend", overQuestion);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("mouseup", overQuestion);
    window.removeEventListener("touchend", overQuestion);
  });

  //选中答案
  function setQuestion(e, msg) {
    msg.isShow = false;
    movingItem.left = (e.clientX || e.targetTouches[0].clientX) - document.getElementById("mm_drag").offsetLeft - document.getElementById("mm_drag").offsetParent.offsetLeft - document.getElementById("mm_dragMove").offsetWidth / 2;
    movingItem.top = (e.clientY || e.targetTouches[0].clientY) - document.getElementById("mm_drag").offsetTop - document.getElementById("mm_drag").offsetParent.offsetTop - document.getElementById("mm_dragMove").offsetHeight / 2;
    for (let key in msg) {
      movingItem[key] = msg[key];
    }
  }
  //松开
  function overQuestion() {
    if (movingItem.isShow) return 0;
    movingItem.isShow = true;
    //拖拽结束后再处理答案
    if (dealingId) {
      answer[dealingId] = "";
      dealingId = null;
    }
    //在可放置位置放置
    if (positionIndex.value >= 0 && distance[positionIndex.value] <= 250000) {
      let domlist = document.getElementsByClassName("questionBox");
      let span = domlist[positionIndex.value].children[0];
      //还原原本答案
      if (answer[span.id] && answer[span.id] != "") {
        questionItem.value.some(item => {
          if (answer[span.id] == item.id) {
            item.isShow = true;
          }
        });
      }
      answer[span.id] = movingItem.id;
    } else {
      questionItem.value.some(item => {
        if (item.id == movingItem.id) {
          item.isShow = true;
          return true;
        }
      });
    }
    movingItem.id = null;
    positionIndex.value = -1;
    setAnswer();
  }
  function moveQuestion(e) {
    e.preventDefault();
    if (!movingItem.isShow) {
      movingItem.left = (e.clientX || e.targetTouches[0].clientX) - document.getElementById("mm_drag").offsetLeft - document.getElementById("mm_drag").offsetParent.offsetLeft - document.getElementById("mm_dragMove").offsetWidth / 2;
      movingItem.top = (e.clientY || e.targetTouches[0].clientY) - document.getElementById("mm_drag").offsetTop - document.getElementById("mm_drag").offsetParent.offsetTop - document.getElementById("mm_dragMove").offsetHeight;
      preview(e);
    }
  }
  //预览插入
  function preview(e) {
    if (movingItem.isShow) return 0;
    nextTick(() => {
      let domlist = document.getElementsByClassName("questionBox");
      let x = e.clientX || e.targetTouches[0].clientX;
      let y = e.clientY || e.targetTouches[0].clientY;
      distance.splice(0, distance.length);
      positionIndex.value = 0;
      for (let i = 0; i < domlist.length; i++) {
        let x1 = domlist[i].getBoundingClientRect().x + domlist[i].offsetWidth / 2;
        let y1 = domlist[i].getBoundingClientRect().y;
        distance[i] = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
        if (distance[i] < distance[positionIndex.value]) positionIndex.value = i;
      }
    });
  }
  function setQuestionFromAnswer(e, id) {
    questionItem.value.some(item => {
      if (item.id == answer[id]) {
        setQuestion(e, item);
        //移除元素
        dealingId = id;
        return true;
      }
    });
  }
  return {
    positionIndex,
    setQuestionFromAnswer,
    setQuestion,
    overQuestion,
    moveQuestion
  };
}